export default __webpack_public_path__ + "locales/el-GR/SmartBanner.json?hash=e759528a044496432ef97893156aaf2a";